export enum AnnotationCategoryKey {
  GENERAL = 'G',
  ARCHITECTURE = 'A',
  STRUCTURE = 'S',
  MECHANICAL = 'M',
  ELECTRICITY = 'E'
}

export interface AnnotationCategoryOption {
  key: string
  label: string
  shortLabel: string
  colorHex: string
  colorClass: string
  bgClass: string
  pointPrefix: string
}

export const RENEWAL_CATEGORY_CONFIG = {
  [AnnotationCategoryKey.GENERAL]: {
    label: '全般',
    colorHex: '#2563EB',
    bgClass: 'bg-[#2563EB]',
    pointPrefix: 'G'
  },
  [AnnotationCategoryKey.ARCHITECTURE]: {
    label: '意匠',
    colorHex: '#E9429D',
    bgClass: 'bg-[#E9429D]',
    pointPrefix: 'A'
  },
  [AnnotationCategoryKey.STRUCTURE]: {
    label: '構造',
    colorHex: '#14B88A',
    bgClass: 'bg-[#14B88A]',
    pointPrefix: 'K'
  },
  [AnnotationCategoryKey.MECHANICAL]: {
    label: '設備',
    colorHex: '#E4A23A',
    bgClass: 'bg-[#E4A23A]',
    pointPrefix: 'M'
  },
  [AnnotationCategoryKey.ELECTRICITY]: {
    label: '電気',
    colorHex: '#F59E0B',
    bgClass: 'bg-[#F59E0B]',
    pointPrefix: 'E'
  }
} as const

export const RENEWAL_CATEGORY_HEX = {
  [AnnotationCategoryKey.GENERAL]: RENEWAL_CATEGORY_CONFIG.G.colorHex,
  [AnnotationCategoryKey.ARCHITECTURE]: RENEWAL_CATEGORY_CONFIG.A.colorHex,
  [AnnotationCategoryKey.STRUCTURE]: RENEWAL_CATEGORY_CONFIG.S.colorHex,
  [AnnotationCategoryKey.MECHANICAL]: RENEWAL_CATEGORY_CONFIG.M.colorHex,
  [AnnotationCategoryKey.ELECTRICITY]: RENEWAL_CATEGORY_CONFIG.E.colorHex
} as const

export const ANNOTATION_CATEGORIES: AnnotationCategoryOption[] = (
  Object.keys(RENEWAL_CATEGORY_CONFIG) as AnnotationCategoryKey[]
).map((key) => {
  const conf = RENEWAL_CATEGORY_CONFIG[key]
  return {
    key,
    label: conf.label,
    shortLabel: conf.label,
    colorHex: conf.colorHex,
    bgClass: conf.bgClass,
    colorClass: `${conf.bgClass} text-white`,
    pointPrefix: conf.pointPrefix
  }
})

export const ANNOTATION_CATEGORY_MAP: Record<string, AnnotationCategoryOption> =
  ANNOTATION_CATEGORIES.reduce(
    (acc, item) => {
      acc[item.key] = item
      return acc
    },
    {} as Record<string, AnnotationCategoryOption>
  )

export const ANNOTATION_CATEGORY_COLORS: Record<string, string> =
  ANNOTATION_CATEGORIES.reduce(
    (acc, item) => {
      acc[item.key] = item.colorClass
      return acc
    },
    {} as Record<string, string>
  )

export const RESOLVED_COMMENT_COLOR = 'rgb(16, 185, 129)'
